export default __webpack_public_path__ + "static/media/AlphaTerms - EULA and Liability Protection.49f646ec.pdf";